import Markdown from 'markdown-to-jsx';
import {useEffect, useState} from 'react';

interface TypeWritterProps {
  text: string;
  delay: number;
  disabled?: boolean;
}

function TypeWritter({text, delay, disabled}: TypeWritterProps) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (disabled) {
      setValue(text);
    } else {
      typeWriterEffect(text);
    }
  }, []);

  function typeWriterEffect(message: string) {
    let index = 0;
    const letters = message.split('');

    const timer = setInterval(() => {
      if (index < letters.length) {
        setValue((prev) => prev + letters[index]);
        index++;
      } else {
        clearInterval(timer);
        index = 0;
      }
    }, delay);
  }

  return <Markdown>{value}</Markdown>;
}

export default TypeWritter;
